module.exports = __webpack_public_path__ + "static/media/code.f07389a4.svg";